import dataBase from '../dataBase/database'
import axios from 'axios'
import { projectService } from './project.service' 
import { networkService } from './network.service'
import { tradepointService } from './tradepoint.service'
import { categoryService } from './category.service'

const API = '/api'

export default {

  // ─── ПРОЕКТЫ ────────────────────────────────────────────────────

  async getProjects() {
    if (navigator.onLine) {
      try {
        let data = await projectService.getMyProjects()
        await dataBase.projects.clear()
        await dataBase.projects.bulkPut(
          data.map(p => ({ ...p, 
            cachedAt: new Date().toISOString() 
          }))
        )
        return data
      } catch (e) {
        console.log(e);
        console.warn('[DataService] getProjects: нет ответа, берём кэш')
      }
    }
    return dataBase.projects.toArray()
  },

  async loadProject(projectId) {
    if(navigator.onLine) {
      try {
        let project = await projectService.loadProject(projectId)
        await dataBase.projects.put({ ...project, 
          cachedAt: new Date().toISOString() 
        })
        return project
      } catch(e) {
        console.log(e);
        console.warn('[DataService] loadProject: нет ответа, берём кэш')
      }
    }
    return dataBase.projects.get(Number(projectId))
  },

  // ─── СЕТИ ───────────────────────────────────────────────────────

  async getNetworks(projectId) {
    if (navigator.onLine) {
      try {
        let data = await networkService.loadMyNetwork(projectId)
        await dataBase.networks.clear()
        await dataBase.networks.bulkPut(
          data.map(n => ({ ...n, 
            projectId: projectId, 
            cachedAt: new Date().toISOString() 
          }))
        )
        return data
      } catch (e) {
        console.warn('[DataService] getNetworks: нет ответа, берём кэш')
      }
    }
    return dataBase.networks.where('projectId').equals(projectId).toArray()
  },

  async loadNetwork(networkId) {
    if(navigator.onLine) {
      try {
        let network = await networkService.loadNetwork(networkId)
        await dataBase.networks.put({ ...network, 
          cachedAt: new Date().toISOString() 
        })
        return network
      } catch(e) {
        console.log(e);
        console.warn('[DataService] loadNetwork: нет ответа, берём кэш')
      }
    }
    return dataBase.networks.get(Number(networkId))
  },

  // ─── ТОЧКИ ──────────────────────────────────────────────────────

  async getPoints(projectId, networkId) {
    if (navigator.onLine) {
      try {
        let data = await tradepointService.getmytradepoints(projectId, networkId)
        await dataBase.points.where('[networkId+projectId]').equals([networkId, projectId]).delete()
        await dataBase.points.bulkPut(
          data.map(p => ({ ...p, 
            projectId: projectId, 
            networkId: networkId, 
            cachedAt: new Date().toISOString() 
          }))
        )
        return data
      } catch (e) {
        console.warn('[DataService] getPoints: нет ответа, берём кэш')
      }
    }
    console.log(dataBase.points.where('[networkId+projectId]').equals([networkId, projectId]).toArray());
    
    return dataBase.points.where('[networkId+projectId]').equals([networkId, projectId]).toArray()
  },

  async loadTradePoint(pointId) {
    if (navigator.onLine) {
      try {
        let tradePoint = await tradepointService.loadPoint(pointId)
        await dataBase.networks.put({ ...tradePoint, cachedAt: new Date().toISOString() })
        return tradePoint
      } catch (e) {
        console.warn('[DataService] getTradePoint: нет ответа, берём кэш')
      }
    }
    return dataBase.points.get(Number(pointId))
  },

  // ─── Категории ───────────────────────────────────────────────────

  async getCategories(pointId, projectId) {
    if (navigator.onLine) {
      try {
        let data = await categoryService.getpointcategories(pointId, projectId)
        await dataBase.categories.where('pointId').equals(pointId).delete()
        await dataBase.categories.bulkPut(
          data.map(p => ({ ...p, 
            pointId: pointId,
            cachedAt: new Date().toISOString() 
          }))
        )
        console.log(dataBase.categories.toArray());
        
        return data
      } catch (e) {
        console.warn('[DataService] getProducts: нет ответа, берём кэш')
      }
    }
    return dataBase.categories.where('pointId').equals(pointId).toArray()
  },

  // ─── ПРОДУКТЫ ───────────────────────────────────────────────────

  async getProducts(pointId) {
    if (navigator.onLine) {
      try {
        const { data } = await axios.get(`${API}/points/${pointId}/products`)
        await dataBase.products.where('pointId').equals(pointId).delete()
        await dataBase.products.bulkPut(
          data.map(p => ({ ...p, pointId, cachedAt: new Date().toISOString() }))
        )
        return data
      } catch (e) {
        console.warn('[DataService] getProducts: нет ответа, берём кэш')
      }
    }
    return dataBase.products.where('pointId').equals(pointId).toArray()
  },

  // ─── ПРЕДЗАГРУЗКА ───────────────────────────────────────────────
  // Вызывай когда пользователь выбрал точку и есть интернет.
  // Скачивает продукты заранее чтобы они были доступны офлайн.

  async prefetchPoint(projectId, networkId, pointId) {
    if (!navigator.onLine) return
    try {
      await this.getProducts(pointId)
      console.log(`[DataService] Точка ${pointId} предзагружена`)
    } catch (e) {
      console.warn('[DataService] Ошибка предзагрузки:', e)
    }
  },
}